import Div from 'src/components/atomic/atom/Div'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import { ReactNode } from 'react'

const ErrTextBox = (props: { children: ReactNode }) => {
  const { children } = props
  return (
    <>
      {children !== null && (
        <Div
          width={'100%'}
          display={'flex'}
          $padding={'10px'}
          $border_radius={'12px'}
          $bgColor={COLOR.red10}
          $margin={'12px auto'}
        >
          <Svg name={'login_error'} $margin={'2px 10px 0 0'} />
          <Span option={'tiny'} color={COLOR.red80} $text_align={'left'}>
            {children}
          </Span>
        </Div>
      )}
    </>
  )
}
export default ErrTextBox
